import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
//enviroment
import {environment} from '../../environments/environment';
import { DefaultComponent } from '../default/default/default.component';
import {AuthGuard} from '../guard/auth.guard';
import {UsuarioResolve} from '../usuario-resolve';
const routes: Routes = [
 
  {
    path: 'default',  component: DefaultComponent, canActivateChild: [AuthGuard], resolve: { default: UsuarioResolve },
    children: [
    { path: '', redirectTo: 'solicitar-servicio' , pathMatch: 'full'  },

    {
      path: 'usuarios',  loadChildren: () => import('../components/usuario/usuario.module' ).then(m => m.UsuarioModule)
    },
    // {
    //   path: 'solicitar-servicio', 
    //   loadChildren: () => import('../components/solicitar-servicio-multiple/solicitar-servicio-multiple.module').then(m => m.SolicitarServicioMultipleModule)
    //  },
     {
      path: 'solicitar-servicio', loadChildren: () => import('../components/solicitar-servicio/solicitar-servicio.module').then(m => m.SolicitarServicioModule)
     },
     {
      path: 'envios', loadChildren: () => import('../components/envios/envios.module' ).then(m => m.EnviosModule)
     },
     {
      path: 'metodo-pago', loadChildren: () => import('../components/metodo-pago/metodo-pago.module' ).then(m => m.MetodoPagoModule)
      },
      {
        path: 'empresa', loadChildren: () => import('../components/compania/empresa/empresa.module' ).then(m => m.EmpresaModule)
      
       },
      {
        path: 'cuenta', loadChildren: () => import('../components/cuenta/cuenta.module' ).then(m => m.CuentaModule)
      },
      {
        path: 'centro-costo', loadChildren: () => import('../components/centro-costo/centro-costo.module' ).then(m => m.CentroCostoModule)
      },
      {
        //NO RECARGA EMPRESAS
        path: 'empresas', loadChildren: () => import('../components/compania/empresas/empresas.module' ).then(m => m.EmpresasModule)
      },
      {
        path: 'reporte-mejoras', loadChildren: () => import('../components/reporte-mejoras/reporte-mejoras.module' ).then(m => m.ReporteMejorasModule)
      },
      {
        path: 'area', loadChildren: () => import('../components/area/area.module' ).then(m => m.AreaModule)
      },
      {
        path: 'reporte-empresarial', loadChildren: () => import('../components/reporte-empresarial/reporte-empresarial.module' ).then(m => m.ReporteEmpresarialModule)
      },
      {
         path: 'reporte-aprobacion', loadChildren: () => import('../components/reporte-aprobacion/reporte-aprobacion.module' ).then(m => m.ReporteAprobacionModule)
      },
      {
        path: 'codigo-promocional', loadChildren: () => import('../components/codigo-promocional/codigo-promocional.module' ).then(m => m.CodigoPromocionalModule)
        },

      {
          path: 'sedes', loadChildren: () => import('../components/sedes/sedes.module' ).then(m => m.SedesModule)
       },
       {
          path: 'configuracion-parametros', loadChildren: () => import('../components/config-parametros/config-parametros.module' ).then(m => m.ConfigParametrosModule)
        
       },
       {
         path: 'sugerencia', loadChildren: () => import('../components/sugerencia/sugerencia.module' ).then(m => m.SugerenciaModule)
      },
      {
         path: 'monitoreo', loadChildren: () => import('../components/monitoreo/monitoreo.module' ).then(m => m.MonitoreoModule)
      },
      {
        path: 'editar-servicio', loadChildren: () => import('../components/editar-servicio/editar-servicio.module' ).then(m => m.EditarServicioModule)
      },
      {
        path: 'dashboard', loadChildren: () => import('../components/dashboard/dashboard.module' ).then(m => m.DashboardModule)
      },
      {path:'servicio-bloque',loadChildren:()=>import('../components/solicitar-servicio-bloque/solicitar-servicio-bloque.module').then(m=>m.SolicitarServicioBloqueModule)},
      { path: 'presupuesto-empresa', loadChildren: () => import('../components/compania/presupuesto-empresa/presupuesto-empresa.module').then(m => m.PresupuestoEmpresaModule) }
    ]
  },
 
  

]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DefaultRoutingModule { }
